import { ActionTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import FacebookPixelState from '../types/FacebookPixelState'

const actions: ActionTree<FacebookPixelState, RootState> = {}

export default actions
